import React from "react";
import { Link } from "react-router-dom";
import MaterialIcon from "../../../shared/components/MaterialIcon";
import { useTranslation } from "../../../i18n";

const ARTICLE_ICONS = {
  defamation: "gavel",
  "reply-best-practices": "forum",
  "deletion-process": "assignment",
  "google-policies": "policy",
  "rating-impact": "analytics",
};

const ARTICLE_KEYS = {
  defamation: {
    title: "documentation.articleDefamation",
    description: "documentation.defamationDesc",
  },
  "reply-best-practices": {
    title: "documentation.articleReply",
    description: "documentation.replyDesc",
  },
  "deletion-process": {
    title: "documentation.articleDeletion",
    description: "documentation.deletionDesc",
  },
  "google-policies": {
    title: "documentation.articleGoogle",
    description: "documentation.googlePoliciesDesc",
  },
  "rating-impact": {
    title: "documentation.articleRating",
    description: "documentation.ratingImpactDesc",
  },
};

const ARTICLE_IDS = Object.keys(ARTICLE_KEYS);

const ClientDocumentationPage = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-background font-body-md text-on-surface">
      <div className="mx-auto max-w-container-max px-margin-mobile py-stack-lg md:px-margin-desktop">
        <h1 className="font-headline-lg text-headline-lg text-primary">
          {t("documentation.title")}
        </h1>
        <p className="mt-2 max-w-2xl text-body-md text-on-surface-variant">
          {t("documentation.subtitle")}
        </p>

        <div className="architect-gradient mt-stack-lg rounded-2xl p-stack-lg">
          <p className="font-label-caps text-inverse-primary/70">
            {t("documentation.featured")}
          </p>
          <h2 className="mt-2 font-headline-md text-inverse-on-surface">
            {t("documentation.articleDefamation")}
          </h2>
          <p className="mt-2 max-w-xl text-[13px] leading-relaxed text-inverse-primary/80">
            {t("documentation.defamationDesc")}
          </p>
          <Link
            to="/dashboard/client/reviews?view=critical"
            className="mt-4 inline-flex items-center gap-2 rounded-lg bg-secondary px-4 py-2 text-label-sm font-medium text-on-primary"
          >
            {t("documentation.reviewCritical")}
            <MaterialIcon name="arrow_forward" />
          </Link>
        </div>

        <div className="mt-stack-lg grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {ARTICLE_IDS.map((id) => (
            <article
              key={id}
              className="tonal-card rounded-xl border border-outline-variant/30 p-stack-lg"
            >
              <MaterialIcon
                name={ARTICLE_ICONS[id]}
                className="mb-3 text-2xl text-secondary"
              />
              <h3 className="font-headline-md text-[16px] text-primary">
                {t(ARTICLE_KEYS[id].title)}
              </h3>
              <p className="mt-2 text-[12px] leading-relaxed text-on-surface-variant">
                {t(ARTICLE_KEYS[id].description)}
              </p>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientDocumentationPage;
